import { render, staticRenderFns } from "./ServiceFiltersService.vue?vue&type=template&id=4fe73123&scoped=true&"
import script from "./ServiceFiltersService.vue?vue&type=script&lang=js&"
export * from "./ServiceFiltersService.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFiltersService.vue?vue&type=style&index=0&id=4fe73123&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe73123",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe73123')) {
      api.createRecord('4fe73123', component.options)
    } else {
      api.reload('4fe73123', component.options)
    }
    module.hot.accept("./ServiceFiltersService.vue?vue&type=template&id=4fe73123&scoped=true&", function () {
      api.rerender('4fe73123', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/ServiceFilters/ServiceFiltersService.vue"
export default component.exports